import { render, staticRenderFns } from "./ColumnasObligatorias.vue?vue&type=template&id=62fab4b8&scoped=true"
import script from "./ColumnasObligatorias.vue?vue&type=script&lang=js"
export * from "./ColumnasObligatorias.vue?vue&type=script&lang=js"
import style0 from "./ColumnasObligatorias.vue?vue&type=style&index=0&id=62fab4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fab4b8",
  null
  
)

export default component.exports